import {
  LK_PROFILE_ROUTE,
  LK_EVENTS_ROUTE,
  USER_ROLES,
} from "shared/config/routes";

export const sidebarTabsByRole = {
  [USER_ROLES.CLIENT]: [
    { label: "Профиль", to: LK_PROFILE_ROUTE },
    { label: "Мероприятия", to: LK_EVENTS_ROUTE },
  ],
  [USER_ROLES.MANAGER]: [
    { label: "Профиль", to: LK_PROFILE_ROUTE },
    { label: "Мероприятия", to: LK_EVENTS_ROUTE },
  ],
};
